// The retargeting (nurturing pool) API error codes and their texts, registered with
// `registerApiErrorCodes` in app.config.ts.
import {
  LEAD_NOT_FOUND_ERROR_CODE,
  RETARGETING_ERROR_CODE_PREFIX,
} from '@features/lead-management/constants/retargeting-error-codes.constants';

/** Retargeting endpoints send their code as the `message`. */
export function isRetargetingMessageCode(message: string): boolean {
  return message.startsWith(RETARGETING_ERROR_CODE_PREFIX) || message === LEAD_NOT_FOUND_ERROR_CODE;
}

/** `lead.retargeting.pool_full` → `pages.leadManagement.nurturingPool.errors.poolFull`. */
export function retargetingErrorTranslationKey(code: string): string | null {
  if (code === LEAD_NOT_FOUND_ERROR_CODE) {
    return 'pages.leadManagement.nurturingPool.errors.notFound';
  }
  if (!code.startsWith(RETARGETING_ERROR_CODE_PREFIX)) return null;
  const suffix = code
    .slice(RETARGETING_ERROR_CODE_PREFIX.length)
    .replace(/_([a-z])/g, (_match, letter: string) => letter.toUpperCase());
  return `pages.leadManagement.nurturingPool.errors.${suffix}`;
}
